<template>
	<div class="drawer">
		<el-drawer
		v-if="detail.caseNumber"
		size="900px"
		title="病例详情"
		:visible.sync="drawerStatus"
		:modal-append-to-body="false"
		:close-on-click-modal="false"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row class="row">
					<el-col :span="12">
						<span class="label">顾客：</span>
						<span class="value">{{detail.memberName}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">宠物：</span>
						<span class="value">{{detail.petName}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">创建时间：</span>
						<span class="value">{{$public.FTime(detail.createTime)}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">账单金额：</span>
						<span class="value">{{detail.totalMoney}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">医生：</span>
						<span class="value">{{detail.doctorName}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">体重：</span>
						<span class="value">{{detail.weight||' -- '}}kg</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">体温：</span>
						<span class="value">{{detail.animalHeat||' -- '}}℃</span>
					</el-col>
					<el-col :span="12">
						<span class="label">呼吸：</span>
						<span class="value">{{detail.breatheRate||' -- '}}次/分</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">心率：</span>
						<span class="value">{{detail.heartRate||' -- '}}次/分</span>
					</el-col>
					<el-col :span="12">
						<span class="label">康复情况：</span>
						<span class="value">
							<span v-if="detail.completeState===1">治愈中</span>
							<span v-if="detail.completeState===2">已治愈</span>
							<span v-if="detail.completeState===3">死亡</span>
							<span v-if="detail.completeState===4">其它</span>
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">病情诊断：</span>
						<span class="value">
							<span v-for="(item1,index1) in detail.diagnosisTags" :key="index1">
								<span v-for="(item2,index2) in item1.symptom" :key="index2">
									<span v-for="(item3,index3) in item2.symptomLevel" :key="index3">
										{{item2.value}}-{{item3.value}} 
									</span>
								</span>
							</span>
						</span>
					</el-col>
					<el-col :span="12">
						<span class="label">主诉：</span>
						<span class="value">
							{{detail.mainContent}}
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12" style="display: flex;">
						<span class="label">临床检查：</span>
						<span class="value">{{detail.clinecContent}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">医嘱：</span>
						<span class="value">{{detail.doctorAdvice}}</span>
					</el-col>
				</el-row>
			</div>
			<div style="margin:0 0">
				<div class="box" v-if="!$public.isNull(detail.inspectItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">检测：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<el-table :data="detail.inspectItem" height="100%">
								<el-table-column prop="no" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="名称" >
									<template slot-scope="scope">
										{{scope.row.goodsName}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="规格" width="100">
									<template slot-scope="scope">
										{{scope.row.skuValue}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="用法">
									<template slot-scope="scope">
										<span v-if="!$public.isNull(scope.row.goodsUsage)">
											{{scope.row.goodsUsage[0]}}
											{{scope.row.goodsUsage[1]}}天{{scope.row.goodsUsage[2]}}次
											{{scope.row.goodsUsage[3]}}{{scope.row.goodsUsage[4]}}/次
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="no" label="价格" >
									<template slot-scope="scope">
										{{scope.row.allowWholesale===1?scope.row.num:scope.row.goodsDosage}}*
										{{(scope.row.price||0).toFixed(2)}}
										元
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="bingqingtotal">
						<div class="total">合计金额：￥{{totalMoney1.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.recipelItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">处方：</span>
					</div>
					<div class="bingqing">
						<div class="table">
							<el-table :data="detail.recipelItem" height="100%">
								<el-table-column prop="no" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="名称" >
									<template slot-scope="scope">
										{{scope.row.goodsName}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="规格" width="100">
									<template slot-scope="scope">
										{{scope.row.skuValue}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="用法">
									<template slot-scope="scope">
										<span v-if="!$public.isNull(scope.row.goodsUsage)">
											{{scope.row.goodsUsage[0]}}
											{{scope.row.goodsUsage[1]}}天{{scope.row.goodsUsage[2]}}次
											{{scope.row.goodsUsage[3]}}{{scope.row.goodsUsage[4]}}/次
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="no" label="价格" >
									<template slot-scope="scope">
										{{scope.row.allowWholesale===1?scope.row.num:scope.row.goodsDosage}}*
										{{(scope.row.price||0).toFixed(2)}}
										元
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="bingqingtotal">
						<div class="total">合计金额：￥{{totalMoney2.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.complicationItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">并发症处方：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<el-table :data="detail.complicationItem" height="100%">
								<el-table-column prop="no" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="名称" >
									<template slot-scope="scope">
										{{scope.row.goodsName}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="规格" width="100">
									<template slot-scope="scope">
										{{scope.row.skuValue}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="用法">
									<template slot-scope="scope">
										<span v-if="!$public.isNull(scope.row.goodsUsage)">
											{{scope.row.goodsUsage[0]}}
											{{scope.row.goodsUsage[1]}}天{{scope.row.goodsUsage[2]}}次
											{{scope.row.goodsUsage[3]}}{{scope.row.goodsUsage[4]}}/次
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="no" label="价格" >
									<template slot-scope="scope">
										{{scope.row.allowWholesale===1?scope.row.num:scope.row.goodsDosage}}*
										{{(scope.row.price||0).toFixed(2)}}
										元
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="bingqingtotal" >
						<div class="total">合计金额：￥{{totalMoney6.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.handleItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">处置：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<el-table :data="detail.handleItem" height="100%">
								<el-table-column prop="no" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="名称" >
									<template slot-scope="scope">
										{{scope.row.goodsName}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="规格" width="100">
									<template slot-scope="scope">
										{{scope.row.skuValue}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="用法">
									<template slot-scope="scope">
										<span v-if="!$public.isNull(scope.row.goodsUsage)">
											{{scope.row.goodsUsage[0]}}
											{{scope.row.goodsUsage[1]}}天{{scope.row.goodsUsage[2]}}次
											{{scope.row.goodsUsage[3]}}{{scope.row.goodsUsage[4]}}/次
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="no" label="价格" >
									<template slot-scope="scope">
										{{scope.row.allowWholesale===1?scope.row.num:scope.row.goodsDosage}}*
										{{(scope.row.price||0).toFixed(2)}}
										元
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="bingqingtotal">
						<div class="total">合计金额：￥{{totalMoney3.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.operationItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">手术：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<el-table :data="detail.operationItem" height="100%">
								<el-table-column prop="no" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="名称" >
									<template slot-scope="scope">
										{{scope.row.goodsName}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="规格" width="100">
									<template slot-scope="scope">
										{{scope.row.skuValue}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="用法">
									<template slot-scope="scope">
										<span v-if="!$public.isNull(scope.row.goodsUsage)">
											{{scope.row.goodsUsage[0]}}
											{{scope.row.goodsUsage[1]}}天{{scope.row.goodsUsage[2]}}次
											{{scope.row.goodsUsage[3]}}{{scope.row.goodsUsage[4]}}/次
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="no" label="价格" >
									<template slot-scope="scope">
										{{scope.row.allowWholesale===1?scope.row.num:scope.row.goodsDosage}}*
										{{(scope.row.price||0).toFixed(2)}}
										元
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="bingqingtotal" >
						<div class="total">合计金额：￥{{totalMoney4.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.inHospitalItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">住院：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<el-table :data="[curPetZhuyuanList]" height="100%">
								<el-table-column prop="no" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="单号" >
									<template slot-scope="scope">
										{{scope.row.id}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="名称" >
									<template >
										{{detail.inHospitalItem[0].goodsName}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="住院时长" width="280">
									<template slot-scope="scope">
										{{$public.FTime(scope.row.beginDate,'YYYY-MM-DD')}}{{$public.FTime(scope.row.endDate,'YYYY-MM-DD')}} |
										{{scope.row.caseInHospitalDuration}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="价格"  width="120">
									<template>
										{{detail.inHospitalItem[0].num}}*
										{{(detail.inHospitalItem[0].price||0).toFixed(2)}}
										元
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="bingqingtotal">
						<div class="total">合计金额：￥{{totalMoney5.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box">
					<div class="bingqing">
						<span style="font-weight: bold;">回访：</span>
						<!-- <span style="color:#5E7BFA">{{$public.FTime(detail.visitDate)}}</span> -->
					</div>
					<div class="bingqing" style="border:0;">
						<div v-if="huifangHistoryList.length>0" class="table">
							<el-table :data="huifangHistoryList" height="100%">
								<el-table-column prop="no" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="回访时间" >
									<template slot-scope="scope">
										{{$public.FTime(scope.row.visitTime)}}
									</template>
								</el-table-column>
								<el-table-column prop="no" label="回访内容" >
									<template slot-scope="scope">
										{{scope.row.visitContent}}
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div v-else style="font-size: 12px;line-height: 40px;text-align: center;">无回访记录</div>
					</div>
				</div>
			</div>
			<!-- <el-row style="padding:50px 20px 0;float: none;font-size: 16px;">
				<el-col :span="4" :offset="16">
					<span class="label">共计：</span>
					<span class="value">{{total.count}}件</span>
				</el-col>
				<el-col :span="4">
					<span class="label">总计：</span>
					<span class="value">￥{{total.money}}</span>
				</el-col>
			</el-row> -->
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				
				detail:{},
				totalMoney1:0,
				totalMoney2:0,
				totalMoney3:0,
				totalMoney4:0,
				totalMoney5:0,
				totalMoney6:0,
				
				curPetZhuyuanList:{},
				
				huifangHistoryList:[],
			}
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.getIllnessCase(this.curItem.caseNumber)
			})
		},
		methods: {
			handleClose(){
				this.$emit("submit",{type:'success'})
			},
			// 获取病例详情
			getIllnessCase(caseNumber) {
				let params = {
					"caseNumber": caseNumber,
					random:Math.random(), // 随机数
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_business+'/api/Case/Detail', params).then(res => {
					loading.close();
					if (res.code == 0) {
						res.data.inspectItem = (res.data.inspectItem||[]).filter(a=>{return a.isPay===true})
						res.data.recipelItem = (res.data.recipelItem||[]).filter(a=>{return a.isPay===true})
						res.data.handleItem = (res.data.handleItem||[]).filter(a=>{return a.isPay===true})
						res.data.operationItem = (res.data.operationItem||[]).filter(a=>{return a.isPay===true})
						res.data.inHospitalItem = (res.data.inHospitalItem||[]).filter(a=>{return a.isPay===true})
						res.data.complicationItem = (res.data.complicationItem||[]).filter(a=>{return a.isPay===true})
						this.detail = res.data;
						this.getTotalMoney()
						this.getHuifangHistory()
						if(this.detail.isCompleted==true){
							return ;
						}else{
							this.detail.inHospitalId&&this.getCurPetZhuyuanList(this.detail.inHospitalId)
						}
					}
				})
			},
			getTotalMoney(){
				let totalMoney1 = 0
				for(let i=0;i<this.detail.inspectItem.length;i++){
					if(this.detail.inspectItem[i].allowWholesale===1){
						totalMoney1 = this.$public.jia(totalMoney1,this.$public.cheng(this.detail.inspectItem[i].price,this.detail.inspectItem[i].num))
					}else{
						totalMoney1 = this.$public.jia(totalMoney1,this.$public.cheng(this.detail.inspectItem[i].price,this.detail.inspectItem[i].goodsDosage))
					}
				}
				let totalMoney2 = 0
				for(let i=0;i<this.detail.recipelItem.length;i++){
					if(this.detail.recipelItem[i].allowWholesale===1){
						totalMoney2 = this.$public.jia(totalMoney2,this.$public.cheng(this.detail.recipelItem[i].price,this.detail.recipelItem[i].num))
					}else{
						totalMoney2 = this.$public.jia(totalMoney2,this.$public.cheng(this.detail.recipelItem[i].price,this.detail.recipelItem[i].goodsDosage))
					}
					
				}
				let totalMoney3 = 0
				for(let i=0;i<this.detail.handleItem.length;i++){
					if(this.detail.handleItem[i].allowWholesale===1){
						totalMoney3 = this.$public.jia(totalMoney3,this.$public.cheng(this.detail.handleItem[i].price,this.detail.handleItem[i].num))
					}else{
						totalMoney3 = this.$public.jia(totalMoney3,this.$public.cheng(this.detail.handleItem[i].price,this.detail.handleItem[i].goodsDosage))
					}
					
				}
				let totalMoney4 = 0
				for(let i=0;i<this.detail.operationItem.length;i++){
					if(this.detail.operationItem[i].allowWholesale===1){
						totalMoney4 = this.$public.jia(totalMoney4,this.$public.cheng(this.detail.operationItem[i].price,this.detail.operationItem[i].num))
					}else{
						totalMoney4 = this.$public.jia(totalMoney4,this.$public.cheng(this.detail.operationItem[i].price,this.detail.operationItem[i].goodsDosage))
					}
					
				}
				let totalMoney5 = 0
				for(let i=0;i<this.detail.inHospitalItem.length;i++){
					if(this.detail.inHospitalItem[i].allowWholesale===1){
						totalMoney5 = this.$public.jia(totalMoney5,this.$public.cheng(this.detail.inHospitalItem[i].price,this.detail.inHospitalItem[i].num))
					}else{
						totalMoney5 = this.$public.jia(totalMoney5,this.$public.cheng(this.detail.inHospitalItem[i].price,this.detail.inHospitalItem[i].goodsDosage))
					}
					
				}
				let totalMoney6 = 0
				for(let i=0;i<this.detail.complicationItem.length;i++){
					if(this.detail.complicationItem[i].allowWholesale===1){
						totalMoney6 = this.$public.jia(totalMoney6,this.$public.cheng(this.detail.complicationItem[i].price,this.detail.complicationItem[i].num))
					}else{
						totalMoney6 = this.$public.jia(totalMoney6,this.$public.cheng(this.detail.complicationItem[i].price,this.detail.complicationItem[i].goodsDosage))
					}
					
				}
				this.totalMoney1 = totalMoney1
				this.totalMoney2 = totalMoney2
				this.totalMoney3 = totalMoney3
				this.totalMoney4 = totalMoney4
				this.totalMoney5 = totalMoney5
				this.totalMoney6 = totalMoney6
			},
			getCurPetZhuyuanList(inHospitalId) {
				let params = {
					"inHospitalId": inHospitalId,
				}
				this.$http.get(process.env.VUE_APP_business+'/api/InHospital/Detail', params).then(res => {
					if (res.code == 0) {
						this.curPetZhuyuanList = res.data;
					}
				})
			},
			getHuifangHistory(){
				let params = {
					caseNumber:this.detail.caseNumber,
				}
				this.$http.get(process.env.VUE_APP_business+'/api/case/reply/list',params).then(res => {
					if(res.code===0){
						this.huifangHistoryList=res.data||[]
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__body{
				overflow: auto;
			}
			.row{
				padding:14px 20px 14px;float: none;font-size: 20px;font-size: 12px;color:#666;border-bottom:1px solid #F2F2F2;
				.label{
					display: inline-block;width:90px;text-align: right;
				}
			}
			.box{
				padding:20px;
				.bingqing{
					
				}
				.bingqingtotal{
					border:0;text-align: right;padding:10px;font-size: 14px;
				}
			}
		}
		
	}
	
</style>
